import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { digitalOcean } from "@/integrations/digitalocean/client";
import { Button } from "@/components/ui/button";
import { FileText } from "lucide-react";

export default function PolicyAcceptance() {
  const navigate = useNavigate();
  const [currentUser, setCurrentUser] = useState(null);

  useEffect(() => {
    loadUser();
  }, []);

  const loadUser = async () => {
    const { data: { session } } = await digitalOcean.auth.getSession();
    if (!session) {
      navigate("/Auth");
      return;
    }
    const { data: profile } = await digitalOcean
      .from("profiles")
      .select("*")
      .eq("id", session.user.id)
      .single();
    setCurrentUser(profile);
  };

  if (!currentUser) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
      </div>
    );
  }

  return (
    <div className="min-h-screen p-8 flex items-center justify-center">
      <div className="max-w-4xl w-full bg-card p-8 rounded-lg border border-border text-center">
        <FileText className="w-16 h-16 mx-auto text-primary mb-6" />
        <h1 className="text-3xl font-bold text-card-foreground mb-4">Review Our Policies</h1>
        <p className="text-muted-foreground mb-8">
          Please review and accept our policies to continue using the platform
        </p>

        <div className="grid md:grid-cols-3 gap-4">
          <div className="bg-muted/50 p-6 rounded-lg">
            <h3 className="font-semibold text-foreground mb-2">Terms of Service</h3>
            <p className="text-sm text-muted-foreground mb-4">
              Review our terms and conditions
            </p>
            <Button onClick={() => navigate("/TOSAcceptance")} className="w-full" tooltip="Review and accept the Terms of Service">
              Review & Accept
            </Button>
          </div>

          <div className="bg-muted/50 p-6 rounded-lg">
            <h3 className="font-semibold text-foreground mb-2">Privacy Policy</h3>
            <p className="text-sm text-muted-foreground mb-4">
              Learn how we protect your data
            </p>
            <Button onClick={() => navigate("/PrivacyPolicyAcceptance")} className="w-full" tooltip="Review and accept the Privacy Policy">
              Review & Accept
            </Button>
          </div>

          <div className="bg-muted/50 p-6 rounded-lg">
            <h3 className="font-semibold text-foreground mb-2">EULA</h3>
            <p className="text-sm text-muted-foreground mb-4">
              End User License Agreement
            </p>
            <Button onClick={() => navigate("/EULAAcceptance")} className="w-full" tooltip="Review and accept the End User License Agreement">
              Review & Accept
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
